<template>
    <v-card width="100%">
        <v-card-title class="justify-center pt-0 pb-2"><h2>Virtual conversations overview</h2></v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            Number of conversations: {{ conversations.length }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-btn color="primary" small @click="refreshAll">Refresh Conversations</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" small @click="createConversation">Create Conversation</v-btn>
            <!-- <v-btn color="error" small @click="deleteAll">Delete Conversations</v-btn> -->
        </v-card-actions>
        <cardVirtualConversationEdit ref="cardVirtualConversationEdit" @updateData="refreshAll"/>
    </v-card>
</template>

<script>
    import cardVirtualConversationEdit from "@/components/syst/openai/cardVirtualConversationEdit.vue";

    export default {
        components: {
            cardVirtualConversationEdit,
        },
        props: {
            conversations: {
                required: true,
            },
            assistants: {
                required: true,
            }
        },
        data() {
            return {
            }
        },
        methods: {              
            refreshAll() {
                this.$emit("updateData", "refresh");
            },
            createConversation() {
                let newConversation = {
                    id: "",
                    assistant_id: "",
                    file_search_only: true,
                }
                this.$refs.cardVirtualConversationEdit.openDialog(newConversation, this.assistants, false);
            }
        }
    }
</script>
